const _get = store => (store.priceOverride ? store.priceOverride : { isLoaded: false });
export const isLoaded = store => _get(store).isLoaded;
export const getPriceOverrides = store => _get(store).priceOverrides;
export const getPriceOverride = store => _get(store).priceOverride;
